import { useContext, useMemo, useRef } from "react";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { useInView } from "framer-motion";
import placeholderImage from "@/assets/img/placeholder-image.png";
import useUtils from "@/hooks/useUtils";
import { context } from "@/Layout";
import Label from "@/components/utils/Label/Label";
import { PostCardPropTypes } from "./propTypes";
import "./styles.scss";

const PostCard = ({ categories, className = "", image, isFeatured, isStacked, link, title }) => {
  const { convertToRelative } = useUtils();

  const decodeTitle = (title) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = title;
    return txt.value;
  };

  const titleRendered = decodeTitle(title);

  const { introShown } = useContext(context) ?? {};

  const ref = useRef(null);

  const isInView = useInView(ref, { once: true });

  // Default animation
  const textAnimation = useMemo(
    () => ({
      transform: isInView && introShown ? "none" : "translateY(40px)",
      opacity: isInView && introShown ? 1 : 0,
      transition: "all 0.5s ease-in-out 0.2s",
    }),
    [isInView, introShown]
  );

  return (
    <div
      className={clsx("post-card", {
        stacked: isStacked,
        featured: isFeatured,
        [className]: className,
      })}
      ref={ref}
    >
      <NavLink to={convertToRelative(link.url)} className="post-card-link" target="_self">
        <img className="post-card-image" src={image?.url ?? placeholderImage} />

        <div className="post-card-details">
          {categories && (
            <div className="post-card-meta">
              {categories.map((category, index) => (
                <Label
                  className="label-primary text-light leading-[14px] inline-block"
                  key={index}
                  text={category}
                />
              ))}
            </div>
          )}

          <p className="post-card-title" style={{ ...textAnimation }}>
            {titleRendered}
          </p>
        </div>

        <div className="post-card-overlay" />
      </NavLink>
    </div>
  );
};

PostCard.propTypes = PostCardPropTypes;

export default PostCard;
